const puzzle = {
  id: "ty0n5v7h2k5l3o2w1x",
  name: "Actors you know but can't name",
  rebuses: [
    {
      clues: [
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "1-2c55-4616-b6d6-29a4ad484d34",
                value: "Jensen Ackles",
              },
            ],
            type: "text",
            solvedText: "Jensen Ackles",
          },
          id: "2-b658-4df4-af9e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/22a.png",
              subtext: "",
              type: "image",
              id: "3-ffd2-473a-93bb-04b6acfd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "4-12c55-4616-b6d6-29a4ad484d34",
                value: "Dacre Montgomery",
              },
            ],
            type: "text",
            solvedText: "Dacre Montgomery",
          },
          id: "5-2b658-4df4-af9e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/17a.png",
              subtext: "",
              type: "image",
              id: "6-3ffd22-473a-93bb-04b6acfd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "7-12c55-4616-b6d6-29a4ad484d34",
                value: "Wallace Shawn",
              },
            ],
            type: "text",
            solvedText: "Wallace Shawn",
          },
          id: "8-2b658-4df4-af9e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/29a.png",
              subtext: "",
              type: "image",
              id: "fc3eb3330-3ffd22-473a-93bb-04b6acfd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "9-12c55-4616-b6d6-29a37774d34",
                value: "George Kennedy",
              },
            ],
            type: "text",
            solvedText: "George Kennedy",
          },
          id: "10-261010-4111-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/20a.png",
              subtext: "",
              type: "image",
              id: "fc3e0101119992-473a-666-04202f53",
            },
          ],
        },
      ],
      style: {},
      id: "11-86ef-4a90-97f9-00489287238b",
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Part 1 complete",
      },
    },
    {
      clues: [
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "12-12c55-4616-b6d6-29a42284d34",
                value: "Judy Greer",
              },
            ],
            type: "text",
            solvedText: "Judy Greer",
          },
          id: "13-2b658-4224-af9e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/23a.png",
              subtext: "",
              type: "image",
              id: "14-3ffd22-473a-93bb-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "15-12c55-4616-b6d6-29a3384d34",
                value: "David Bradley",
              },
            ],
            type: "text",
            solvedText: "David Bradley",
          },
          id: "16-2b658-4224-a3e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/18a.png",
              subtext: "",
              type: "image",
              id: "17-3ffd22-473a-33bb-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "18-12c55-4616-b6d6-29a3384d34",
                value: "Maggie Wheeler",
              },
            ],
            type: "text",
            solvedText: "Maggie Wheeler",
          },
          id: "19-2b658-4224-a3e-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/25a.png",
              subtext: "",
              type: "image",
              id: "20-3ffd22-473a-33bb-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "21-12c55-4616-b6d6-29a37774d34",
                value: "David Morse",
              },
            ],
            type: "text",
            solvedText: "David Morse",
          },
          id: "22-26668-4774-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/19a.png",
              subtext: "",
              type: "image",
              id: "23-3ff7772-473a-666-04222fd2f53",
            },
          ],
        },
      ],
      style: {},
      id: "24-86ef-4a90-97222-00489287238b",
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Part 2 complete",
      },
    },
    {
      clues: [
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "25-12c55-4616-b6d6-29a35554d34",
                value: "Breckin Meyer",
              },
            ],
            type: "text",
            solvedText: "Breckin Meyer",
          },
          id: "26-2b658-4224-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/16a.png",
              subtext: "",
              type: "image",
              id: "27-3ffd22-473a-33bb-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "28-12c55-4616-b6d6-29a36664d34",
                value: "Giovanni Ribisi",
              },
              {
                id: "28222-12c55-4616-b6d6-29a36664d34",
                value: "Antonino Giovanni Ribisi",
              },
            ],
            type: "text",
            solvedText: "Giovanni Ribisi",
          },
          id: "29-26668-4224-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/21a.png",
              subtext: "",
              type: "image",
              id: "30-3ffd22-473a-666-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "31-12c55-4616-b6d6-29a37774d34",
                value: "Stacey Dash",
              },
            ],
            type: "text",
            solvedText: "Stacey Dash",
          },
          id: "32-26668-4774-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/27a.png",
              subtext: "",
              type: "image",
              id: "33-3ff7772-473a-666-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "34-12c55-4616-b6d6-29a37774d34",
                value: "Liev Schreiber",
              },
            ],
            type: "text",
            solvedText: "Liev Schreiber",
          },
          id: "35-261010-4704-a555-286c04c0ed13",
          style: { width: "calc(25% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/24a.png",
              subtext: "",
              type: "image",
              id: "36-3ff99992-473a-666-04202f53",
            },
          ],
        },
      ],
      style: {},
      id: "37-86ef-4a90-97222-00489287238b",
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Part 3 complete",
      },
    },
    {
      clues: [
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "38-12c55-4616-b6d6-29a37774d34",
                value: "Michael Rooker",
              },
            ],
            type: "text",
            solvedText: "Michael Rooker",
          },
          id: "39-26998-4774-a555-286c04c0ed13",
          style: { width: "calc(33% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/26a.png",
              subtext: "",
              type: "image",
              id: "40-3ff99992-473a-666-04222fd2f53",
            },
          ],
        },
        {
          helperText: "",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "41-12c55-4616-b6d6-29a37774d34",
                value: "Tony Shalhoub",
              },
            ],
            type: "text",
            solvedText: "Tony Shalhoub",
          },
          id: "42-26998-4704-a555-286c04c0ed13",
          style: { width: "calc(33% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/ty0n5v7h2k5l3o2w1x/28a.png",
              subtext: "",
              type: "image",
              id: "43-3ff99992-473a-666-04202f53",
            },
          ],
        },
      ],
      style: {},
      id: "44-4a90-97222-00489287238b",
      isUnlocked: true,
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Part 4 complete",
      },
    },
  ],
};

export default puzzle;
